import { render, staticRenderFns } from "./RankingsTableScrolling.vue?vue&type=template&id=3c43a3d5&scoped=true"
import script from "./RankingsTableScrolling.vue?vue&type=script&lang=js"
export * from "./RankingsTableScrolling.vue?vue&type=script&lang=js"
import style0 from "./RankingsTableScrolling.vue?vue&type=style&index=0&id=3c43a3d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c43a3d5",
  null
  
)

export default component.exports